<snt-button
  [icon]="current?.icon"
  [title]="current?.display"
  (onClickAsync)="onToggle($event)"
  class="flex-1"
></snt-button>
